import { Box } from "@mantine/core";
import { Suspense, lazy, useEffect } from "react";
import { trackLandingPageViewed } from "../utils/landing-analytics";
import classes from "./LandingPage.module.css";
import LandingHero from "./LandingHero";
import { usePostHog } from "@/lib/posthog";

// Lazy load below-the-fold sections for better initial load performance
const HowItWorksSection = lazy(() => import("./HowItWorksSection"));
const DifferentiationSection = lazy(() => import("./DifferentiationSection"));
const ValuePropsSection = lazy(() => import("./ValuePropsSection"));
const ProactiveSection = lazy(() => import("./ProactiveSection"));
const CategoriesSection = lazy(() => import("./CategoriesSection"));
const FeaturesSection = lazy(() => import("./FeaturesSection"));
const ComingSoonSection = lazy(() => import("./ComingSoonSection"));
const FinalCTASection = lazy(() => import("./FinalCTASection"));

export default function LandingPage() {
  const posthog = usePostHog();

  useEffect(() => {
    trackLandingPageViewed(posthog, {
      referrer:
        typeof document !== "undefined" ? document.referrer || undefined : undefined,
    });
  }, [posthog]);

  return (
    <Box className={classes.root}>
      <LandingHero />
      <Suspense fallback={<Box style={{ minHeight: "100vh" }} />}>
        <HowItWorksSection />
        <DifferentiationSection />
        <ValuePropsSection />
        <ProactiveSection />
        <CategoriesSection />
        <FeaturesSection />
        <ComingSoonSection />
        <FinalCTASection />
      </Suspense>
    </Box>
  );
}
